import { createFileRoute, Navigate } from '@tanstack/react-router'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'
import { TotalEmissions } from '@/features/Sustainability/components/TotalEmissions/TotalEmissions'

export const Route = createFileRoute('/_layout/sustainability/total-emissions')(
    {
        component: RouteComponent,
    }
)

function RouteComponent() {
    return (
        <>
            <RoleRestrictedContent
                allowedRoles={[UserType.AGENT, UserType.BROKER]}
            >
                <Navigate to={'/dashboard'} />
            </RoleRestrictedContent>

            <RoleRestrictedContent
                allowedRoles={[UserType.CUSTOMER]}
                strict={false}
            >
                <TotalEmissions />
            </RoleRestrictedContent>
        </>
    )
}
